<script>

  import {API_VILLAGE} from '../common/api'
  import {rangeVillage} from '../assets/js/funcs'

  export default {
    name: 'UserList',
    data() {
      return {
        loading: true,
        currentPage: 1,
        pageSize: 25,
        tableData: [],
        totalCount: 1,
        tableHeight: 200,
        addDialogVisible: false,
        updateDialogVisible: false,
        operateId: 0
      }
    },
    created() {
      window.addEventListener('resize', this.setTableHeight);
    },
    destroyed() {
      window.removeEventListener('resize', this.setTableHeight)
    },
    methods: {
      // 设置表格高度
      setTableHeight() {
        this.tableHeight = window.innerHeight - 150
      },
      // 修改每页显示条数时，查询
      handleSizeChange(pageSize) {
        this.currentPage = 1;
        this.pageSize = pageSize;
        this.getDataList()
      },
      // 修改页数时，查询
      handleCurrentChange(page) {
        this.currentPage = page;
        this.getDataList()
      },
      // 搜索列表
      searchData() {
        this.currentPage = 1;
        this.getDataList();
      },
      // 新增成功回调
      addSuccess() {
        this.addDialogVisible = false;
        this.$message.success('新增成功');
        this.getDataList()
      },
      // 显示修改页面
      showUpdate(id) {
        this.operateId = id;
        this.updateDialogVisible = true;
      },
      // 修改成功回调
      updateSuccess() {
        this.updateDialogVisible = false;
        this.$message.success('修改成功');
        this.getDataList()
      },
      // 删除
      showDelete(id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteData(id)
        }).catch((err) => {
          this.$message.error(err.msg);
        });
      },
      tip(msg) {
        this.$message.warning(msg);
      },

      // 获取小区列表
      getVillageList() {
        if (this.$store.state.village.villageList.length > 0) {
          // console.log('已经存在小区数据，不用重新请求');
          return;
        }
        let params = {
          page_no: 1,
          page_num: 1000
        };
        this.$http.GET(API_VILLAGE, params,
          res => {
            this.$store.commit('setVillage', res.result.list);
            this.$store.commit('setArrangeVillage', rangeVillage(res.result.list));
          }, err => {
            this.$message.error(err.msg);
          }
        );
      }
    }
  }
</script>

<template>

</template>

<style lang="scss" scoped>

  @import '../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/BaseList.vue